import { Component, OnInit, ViewChild } from '@angular/core';
import { StripeCardComponent, injectStripe } from 'ngx-stripe';
import { BaseComponent } from 'src/app/core/base.component';
import { SessionService } from '../../services/session.service';
import { GtStripeService } from '../../services/gt-stripe.service';
import { PaymentMethodResult, SetupIntent, StripeCardElementOptions, StripeElementsOptions } from '@stripe/stripe-js';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';

@Component({
    selector: 'stripe-add-payment-modal',
    templateUrl: './stripe-add-payment-modal.component.html',
    styleUrl: './stripe-add-payment-modal.component.scss',
    standalone: false
})
export class StripeAddPaymentModalComponent extends BaseModalComponent implements OnInit {
  readonly stripe = injectStripe();
  
  @ViewChild(StripeCardComponent) cardElement!: StripeCardComponent;
  
  public showCloseButton: boolean = true;
  public customerId: string;
  public isDefault: boolean = true;
  public isDefaultDisabled: boolean = false;
  private setupIntent: any;
  public isCardValid: boolean = false;

  public states: string[] = [
    'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
    'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
    'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
    'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
    'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY', 'DC'
  ];

  public billingForm: FormGroup = new FormGroup({
    firstName: new FormControl('', {
      validators: Validators.required
    }),
    lastName: new FormControl('', {
      validators: Validators.required
    }),
    city: new FormControl('', {
      validators: Validators.required
    }),
    country: new FormControl('US', {
      validators: Validators.required
    }),
    state: new FormControl('', {
      validators: Validators.required
    }),
    postalCode: new FormControl('', {
      validators: Validators.required
    }),
    address1: new FormControl('', {
      validators: Validators.required
    }),
    address2: new FormControl(),
    email: new FormControl(),
  });

  public cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        fontFamily: 'Poppins, sans-serif',
        fontSize: '18px',
      },
    },
  };

  public elementsOptions: StripeElementsOptions = {
    appearance: {
      theme: 'stripe'
    },
    locale: 'en',
  };

  constructor(public sessionService: SessionService,
    private stripeService: GtStripeService,
    private dialogRef: MatDialogRef<StripeAddPaymentModalComponent>){
    super();
  }

  ngOnInit(): void {
    this.createSetupIntent();
    this.billingForm.get('email').patchValue(this.sessionService.getUser().email);
  }


  createSetupIntent() {
    this.isLoading = true;
    this.stripeService.createSetupIntent({
      customer: this.customerId,
      payment_method_types: ["card"]
    }).subscribe({
      next: (result: any) => {
        this.setupIntent = result;
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => this.isLoading = false
    });
  }

  savePayment() {
    this.isLoading = true;
    this.stripe.createPaymentMethod({
      type: 'card',
      card: this.cardElement.element,
      billing_details: {
        name: `${this.billingForm.get('firstName').value} ${this.billingForm.get('lastName').value}`,
        address: {
          city: this.billingForm.get('city').value,
          country: this.billingForm.get('country').value,
          line1: this.billingForm.get('address1').value,
          line2: this.billingForm.get('address2').value,
          postal_code: this.billingForm.get('postalCode').value,
          state: this.billingForm.get('state').value,
        },
        email: this.billingForm.get('email').value,
      }
    }).subscribe({
      next: (result: PaymentMethodResult) => {
        this.stripeService.confirmSetupIntent(this.setupIntent.id, {
          payment_method: result.paymentMethod.id,
          accountId: this.sessionService.getUser().stripeAccountId,
          isDefault: this.isDefault
        }).subscribe(result => {
          this.dialogRef.close({message: "save", paymentMethod: result});
        }, err => {
          this.isLoading = false;
        });
      },
      error: (err) => {
        this.isLoading = false;
        console.log(err);
      }
    });
  }

  cancelSetupIntent(){
    this.stripeService.cancelSetupIntent(this.setupIntent.id).subscribe({
      next: (result: any) => {
        this.dialogRef.close();
      },
      error: (err) => {
        this.isLoading = false;
        console.log(err);
      },
      complete: () => this.isLoading = false
    });
  }

  onCardChange(event: any): void {
    this.isCardValid = event.complete && !event.error;
  }
}
